import { connect } from 'react-redux';
import SiteMaintenance from './siteMaintenance';
import { bindActionCreators } from 'redux';
import {
  getSiteListing,
  getSiteFilters,
  UploadFlat,
} from 'services/redux/brandActivtion/siteMaintenance/action';

const mapStateToProps = (state) => ({
  siteListData: state.baSiteListingReducer.siteListData,
  siteFilters: state.baSiteListingReducer.siteFiltersData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteListing,
      getSiteFilters,
      UploadFlat,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteMaintenance);
